import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const ExclamationLine14 = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.99984 3.50002C7.24146 3.50002 7.43734 3.69589 7.43734 3.93752V7.87502C7.43734 8.11664 7.24146 8.31252 6.99984 8.31252C6.75821 8.31252 6.56234 8.11664 6.56234 7.87502V3.93752C6.56234 3.69589 6.75821 3.50002 6.99984 3.50002Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.65609 9.84377C7.65609 10.2062 7.36227 10.5 6.99984 10.5C6.6374 10.5 6.34359 10.2062 6.34359 9.84377C6.34359 9.48133 6.6374 9.18752 6.99984 9.18752C7.36227 9.18752 7.65609 9.48133 7.65609 9.84377Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.99961 0.131287C3.2061 0.131287 0.130859 3.20653 0.130859 7.00004C0.130859 10.7935 3.2061 13.8688 6.99961 13.8688C10.7931 13.8688 13.8684 10.7935 13.8684 7.00004C13.8684 3.20653 10.7931 0.131287 6.99961 0.131287ZM1.00586 7.00004C1.00586 3.68978 3.68935 1.00629 6.99961 1.00629C10.3099 1.00629 12.9934 3.68978 12.9934 7.00004C12.9934 10.3103 10.3099 12.9938 6.99961 12.9938C3.68935 12.9938 1.00586 10.3103 1.00586 7.00004Z"
            })
        ]
    });
